import React from 'react';

// IMAGES
import ImgFacebook from '../../images/Share/facebook.svg'
import ImgTwitter from '../../images/Share/gorjeo.svg'
import ImgWhatsapp from '../../images/Share/whatsapp.svg'
import ImgLinkedin from '../../images/Share/linkedin-icon.svg'
import LinkImageShare from '../../atoms/Refactorizaction/LinkImageShare';

const SharePortfolio = () => (
    <section className="share-portfolio">
        {/* FACEBOOK */}
        < LinkImageShare ClassNameShare="facebook"  ImageRed={ImgFacebook} LinkShare="https://www.facebook.com/sharer/sharer.php?u=https://eliudcesar.netlify.app/"                            />
        {/* TWITTER */}
        < LinkImageShare ClassNameShare="twitter"   ImageRed={ImgTwitter}  LinkShare="https://twitter.com/intent/tweet?text= Portafolio de Eliud Cesar: &url=https://eliudcesar.netlify.app/"  />
        {/* WHATSAPP */}
        < LinkImageShare ClassNameShare="whatsapp"  ImageRed={ImgWhatsapp} LinkShare="https://api.whatsapp.com/send?text= Portafolio de Eliud Cesar: https://eliudcesar.netlify.app/"          />
        {/* LINKEDIN */}
        < LinkImageShare ClassNameShare="copy-link" ImageRed={ImgLinkedin} LinkShare="https://www.linkedin.com/sharing/share-offsite/?url=https://eliudcesar.netlify.app/"                     />
    </section>
)

export default SharePortfolio;
